/**
 * API client with authentication
 */
import axios, { AxiosInstance } from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'
import { config } from '../config'

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add auth token to requests
apiClient.interceptors.request.use(
  async (requestConfig) => {
    try {
      const session = await fetchAuthSession()
      // Use idToken (not accessToken) - Cognito OAuth access tokens don't have 'aud' claim
      // which API Gateway JWT authorizer requires for audience validation
      const token = session.tokens?.idToken?.toString()

      if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      // User not authenticated, continue without token
      if (config.features.debugMode) {
        console.log('No auth session available')
      }
    }

    return requestConfig
  },
  (error) => Promise.reject(error)
)

// Handle response errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - could trigger re-auth here
      console.error('Authentication error:', error.response.data)
    }

    return Promise.reject(error)
  }
)

export { apiClient }
